import { resolve } from 'path';
import chalk from 'chalk';
import { MemoryWatcher } from '../core/watcher.js';
import { info, error } from '../utils/prompt.js';
import { WatchOptions } from '../types/index.js';

/**
 * Watch command - monitor and auto-sync memory files
 */
export async function watchCommand(options: WatchOptions): Promise<void> {
  const directory = options.directory ? resolve(options.directory) : process.cwd();

  console.log(chalk.bold('\n👀 Watch Mode\n'));
  console.log(chalk.dim(`Watching: ${directory}\n`));

  const watcher = new MemoryWatcher(directory);

  try {
    // Initialize watcher
    await watcher.initialize();

    // Start watching
    await watcher.watch();

    // Keep process running
    process.on('SIGINT', async () => {
      console.log('\n');
      info('Stopping watcher...');
      await watcher.stop();
      console.log();
      process.exit(0);
    });
  } catch (err) {
    error(`Watch failed: ${(err as Error).message}`);
    process.exit(1);
  }
}
